<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input v-model="args['itemCategory.name']" :placeholder="$t('business.label.categoryName')" allowClear @pressEnter="getTableData"/>
      <a-input v-model="args['itemCategory.no']" :placeholder="$t('business.label.categoryNo')" allowClear @pressEnter="getTableData"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <a-row type="flex">
      <a-col :span="6">
        <valid-config-tree ref="tree" @onSelected="onSelected"/>
      </a-col>
      <a-col :span="18">
        <valid-config-table ref="table"/>
      </a-col>
    </a-row>
  </a-layout>
</template>

<script>
import ValidConfigTable from '@/views/config/validConfig/ValidConfigTable.vue'
import ValidConfigTree from '@/views/config/validConfig/ValidConfigTree.vue'

export default {
  name: 'ValidConfig',
  components: { ValidConfigTable, ValidConfigTree },
  data() {
    return {
      args: { 'itemCategory.name': '', 'itemCategory.no': '' }
    }
  },
  methods: {
    onSelected(classification) {
      this.$refs.table.getData(classification)
    },
    save() {
      this.$refs.table.save()
    },
    refresh() {
      this.$refs.tree.refresh()
    },
    add() {
      this.$refs.table.add()
    },
    getTableData() {
      this.$refs.table.search(undefined, this.args)
    }
  }
}
</script>